// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2wGzg","header":"ReportDetails_header__1XBjG","title":"ReportDetails_title__1W6P-","left":"ReportDetails_left__3JIS0"};